module.exports = __webpack_public_path__ + "img/subordinate_bg3.4d3c6669.png";